import { render, staticRenderFns } from "./BlockchainCryptoPickerSlim.vue?vue&type=template&id=fa0cdf8a&"
import script from "./BlockchainCryptoPickerSlim.vue?vue&type=script&lang=js&"
export * from "./BlockchainCryptoPickerSlim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VFlex,VListItemContent})
